const removeAccents = require( 'remove-accents' );

const formatName = ( identifier ) => {
    return identifier.split( '.' )[ 0 ]
        .replace('asa', 'åsa')
        .replace('goran', 'göran')
        .replace('hakan', 'håkan')
        .replace('lars-hakan', 'lars-håkan')
        .replace('soren', 'sören')
        .replace('host/', '')
        .replace('janarne', 'Jan-Arne');
};

// Names that sound the same but are spelled differently (Oscar/Oskar,
// Christofer/Kristofer, Philip/Filip) should count as the same name, so they
// share one comparison key. Used for both grouping first names and search.
const toSoundKey = ( text ) => {
    return removeAccents( text.toLowerCase() )
        .replace( /ch/g, 'k' )
        .replace( /ph/g, 'f' )
        .replace( /c/g, 'k' )
        .replace( /w/g, 'v' )
        .replace( /z/g, 's' )
        .replace( /(.)\1+/g, '$1' );
};

const getFirstNameKey = ( identity ) => {
    return toSoundKey( identity.split( '.' )[ 0 ] );
};

// Capitalises the first letter of each word and after a hyphen (anna-karin →
// Anna-Karin), so the name reads the same wherever it's shown.
const capitalise = ( name ) => {
    return name.replace( /(^|[\s-])(\p{L})/gu, ( match, separator, letter ) => {
        return separator + letter.toUpperCase();
    } );
};

const getLastNameInitial = ( identity ) => {
    const lastName = identity.split( '.' )[ 1 ];

    return lastName ? lastName.charAt( 0 ).toUpperCase() : '';
};

// Maps each identity to the name shown on screen: just the first name, plus
// the last name's initial when someone else shares (or sounds like) it.
const buildDisplayNames = ( identities ) => {
    const groups = new Map();

    identities.forEach( ( identity ) => {
        const key = getFirstNameKey( identity );

        if ( !groups.has( key ) ) {
            groups.set( key, new Set() );
        }

        groups.get( key ).add( identity );
    } );

    const displayNames = new Map();

    groups.forEach( ( groupIdentities ) => {
        groupIdentities.forEach( ( identity ) => {
            const initial = getLastNameInitial( identity );

            displayNames.set(
                identity,
                capitalise(
                    groupIdentities.size > 1 && initial
                        ? `${ formatName( identity ) } ${ initial }`
                        : formatName( identity )
                )
            );
        } );
    } );

    return displayNames;
};

module.exports = formatName;
module.exports.buildDisplayNames = buildDisplayNames;
module.exports.toSoundKey = toSoundKey;
